module.exports = __webpack_public_path__ + "static/media/smartphone.7e4807d8.svg";